import type { Currency, SettlementReceiptShare } from "@/api/types";
import { MoneyAmount } from "./MoneyAmount";
import "./receipt-share-list.css";

export interface ReceiptShareListProps {
  shares: ReadonlyArray<SettlementReceiptShare>;
  ccy: Currency;
  provisional?: boolean;
}

/**
 * The breakdown rows under a BalanceRow / TransferCard. Shared between
 * the two views of SettleUpScreen (План / Хто кому винен) so the visual
 * treatment stays identical (per openapi v0.3.2 — same shape on both sides).
 */
export function ReceiptShareList({ shares, ccy, provisional }: ReceiptShareListProps) {
  if (!shares.length) return null;
  return (
    <ul className="wp-shares" aria-label="Розбивка по чеках">
      {shares.map((s) => (
        <li key={s.receipt_id} className="wp-shares__row">
          <span className="wp-shares__title">{s.receipt_title}</span>
          <MoneyAmount value={s.amount} ccy={ccy} size="caption" provisional={provisional} />
        </li>
      ))}
    </ul>
  );
}
